import { render } from "./PNBOpeningView.vue?vue&type=template&id=627e8721&scoped=true"
import script from "./PNBOpeningView.vue?vue&type=script&lang=js"
export * from "./PNBOpeningView.vue?vue&type=script&lang=js"

import "./PNBOpeningView.vue?vue&type=style&index=0&id=627e8721&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627e8721"]])

export default __exports__